module.exports = __webpack_public_path__ + "static/img/global-round-trip.cb42922.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/global-round-trip.jpg
// module id = 6M2c
// module chunks = 4